import { createAction, createReducer } from 'redux-act';
import Immutable from 'seamless-immutable';

const INITIAL_STATE = Immutable({
  signalRconnected: null,
  shouldPlaySound: false,
  pendingScannerInput: null,
  options: {
    preOrderDaysAheadAllowed: 0,
  },
  localSettings: {
    useEposPrinter: false,
    ePosPrinterIP: '',
    ePosPrinterPort: window.location.protocol.startsWith('https') ? '8043' : '8008',
    autoprintNewOrders: true,
    enableRouteplanning: false,
    showSidebar: true,
    showTickets: true,
    showOrderHistory: true,
    showTomorrow: false,
    showSecondNextDay: false,
    showTotalPrice: false,
    showArticlePrice: false,
    printTotalPrice: false,
    printArticlePrice: false,
    showTip: true,
    showEventName: false,
    openAlertForNewOrder: false,
    autoNextOnScan: true,
    soundName: 'alert.mp3',
    showProductionPlaceFilter: false,
    showOrderSpotFilter: false,
    sortSpotAlphabetical: false,
    searchResetValue: 60,
  },
  isSettingsDialogOpen: false,
  inButtonActivatedFullScreen: false,
  showToggleFullScreenButton: !(((window.fullScreen) || (window.innerWidth === window.screen.width && window.innerHeight === window.screen.height))),
  scrollTopOrderGridFunction: () => {},
});

export const setSignalRState = createAction('SETSIGNALRSTATE');
export const setAlertSoundState = createAction('SETSOUNDSTATE');
export const setPendingScannerInput = createAction('setPendingScannerInput');

export const loadUiOptions = createAction('LOADUIOPTIONS');
export const loadUiOptionsSucceeded = createAction('LOADUIOPTIONSSUCCEEDED');
export const loadUiOptionsFailed = createAction('LOADUIOPTIONSFAILED');

export const setWindowSize = createAction('SETWINDOWSIZE');
export const toggleFullScreen = createAction('TOGGLEFULLSCREEN');

export const openSettingsDialog = createAction('OPENSETTINGSDIALOG');
export const closeSettingsDialog = createAction('CLOSESETTINGSDIALOG');
export const changeLocalSettings = createAction('CHANGELOCALSETTINGS');

export const registerScrollTopOrderGridFunction = createAction('REGISTERSCROLLTOPORDERGRIDFUNCTION');

const reducers = createReducer({
  [setSignalRState]: (state, signalRconnected) => state.merge({ signalRconnected }),
  [loadUiOptionsSucceeded]: (state, options) => state.merge({ options }),
  [setAlertSoundState]: (state, shouldPlaySound) => state.merge({ shouldPlaySound }),
  [setWindowSize]: (state, windowsize) => state.merge({ windowsize }),
  [openSettingsDialog]: state => state.merge({ isSettingsDialogOpen: true }),
  [closeSettingsDialog]: state => state.merge({ isSettingsDialogOpen: false }),
  [changeLocalSettings]: (state, { key, value }) => {
    const localSettings = state.localSettings.asMutable();
    localSettings[key] = value;

    return state.merge({ localSettings });
  },
  [toggleFullScreen]: state => state.merge({ inButtonActivatedFullScreen: !state.inButtonActivatedFullScreen }),
  [registerScrollTopOrderGridFunction]: (state, scrollFunction) => state.merge({ scrollTopOrderGridFunction: scrollFunction }),
}, INITIAL_STATE);

export default reducers;
